// extracted by mini-css-extract-plugin
module.exports = {"note":"PressAssetRequestNote_note__5cUJq"};